import environment from "../environments/environment";

/**
 * Resolve uploaded / relative media paths against the API host.
 * Backend stores nested paths like "/uploads/products/SKU-001/uuid_file.jpg".
 */
export function mediaUrl(path?: string | null): string {
  if (path == null) return "";
  const value = String(path).trim();
  if (!value) return "";

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  // Static assets from the React public folder
  if (value.startsWith("/Assets/") || value.startsWith("Assets/")) {
    return value.startsWith("/") ? value : `/${value}`;
  }

  const base = environment.Base_URL.replace(/\/$/, "");
  let relative = value.replace(/\\/g, "/");
  if (relative.startsWith("uploads/")) relative = `/${relative}`;
  if (!relative.startsWith("/uploads/")) {
    relative = `/uploads/${relative.replace(/^\//, "")}`;
  }

  // Encode each path segment so names with spaces (e.g. "GD 27.jpeg") load correctly
  const encoded = relative
    .split("/")
    .map((seg, i) => (i === 0 ? "" : encodeURIComponent(seg)))
    .join("/");

  return `${base}${encoded}`;
}
